module.exports = __webpack_public_path__ + "static/media/plan-wom-250gb-wom62.e0d1d3b9.svg";